enum iconNames {
    appointment = 'appointment',
    cardlist = 'cardlist',
    chat = 'chat',
    clock = 'clock',
    exit = 'exit',
    gear = 'gear',
    trophy = 'trophy',
    handbag = 'handbag',
    packageClosed = 'packageClosed',
    truck = 'truck',
    userCircle = 'userCircle'
}

export default iconNames;
